<template>
  <div class="col-xxl-4 col-sm-12 box-col-12">
    <div class="card profile-box">
      <div class="card-body">
        <div class="media">
          <div class="media-body">
            <div class="greeting-user">
              <h4 class="f-w-600 mb-0">{{ t("orderSummary") }}</h4>
              <p>{{ this.eventDetails.title }}</p>
              <!-- <p>{{ this.eventDetails.event_date }},{{ this.eventDetails.province }}</p> -->

              <p>&nbsp;</p>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
        <div class="cartoon">
          <img
            class="img-fluid"
            src="@/assets/images/dashboard/cartoon.svg"
            alt="vector women with leptop"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.btn:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #fff !important;
  opacity: 0.65;
  cursor: not-allowed !important;
}
.table-fit {
  width: 1px;
}
</style>
<script>
import axios from "axios";

const LANGUAGE_TEXT = {
  en: {
    orderSummary: "Order Summary",
    eventDetailError:
      "[EventDetail]An error has occurred. Please contact the system administrator!",
  },
  th: {
    orderSummary: "สรุปคำสั่งซื้อ",
    eventDetailError:
      "[EventDetail]An error has occurred. Please contact the system administrator!",
  },
};

export default {
  data() {
    return {
      eventDetails: {},
    };
  },
  computed: {
    currentLanguage() {
      return (process.env.VUE_APP_LANGUAGE || "").toLowerCase() === "en"
        ? "en"
        : "th";
    },
  },
  mounted() {},

  methods: {
    t(key) {
      return LANGUAGE_TEXT[this.currentLanguage][key] || LANGUAGE_TEXT.en[key] || key;
    },
  },

  async created() {
    const res = await axios.get("/v1/events/" + this.$route.params.q);
    //console.log("res.data", JSON.stringify(res.data));
    if (res.data.status === "success") {
      this.eventDetails = res.data;
      this.eventPackage = res.data.package;
      return res.data;
    } else {
      alert(this.t("eventDetailError"));
      this.$router.push({ path: "/" });
    }
  },
};
</script>
